import { render, staticRenderFns } from "./PageHomeCollections.vue?vue&type=template&id=5ae7fc37&scoped=true&"
import script from "./PageHomeCollections.vue?vue&type=script&lang=js&"
export * from "./PageHomeCollections.vue?vue&type=script&lang=js&"
import style0 from "./PageHomeCollections.vue?vue&type=style&index=0&id=5ae7fc37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae7fc37",
  null
  
)

export default component.exports